/** @format */
import { Suspense, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { Col, Grid, Row } from '@vds/grids';
import { addOfferStatus, getLanguageBasedHref, getWithExpiry, setWithExpiry, getSuggestionData  } from './utility/utils'
import LZString from 'lz-string'
// import { SuggestionProvider } from './context/SuggestionContext';

import './App.scss';
import { updateCatalogData, updateNotifications,updateRecommendedCourses } from './store/adoberesources';
import { updateAEMRegisterData, updateArticleContent, updateRegistrationStepTopics, updateAEMQuickTIpsData, updateAEMJsonData, updateAICommonData, updateAEMOffersJsonData, updateSpanish, updateUiLocaledata, updateLangSpanish, addFAQ, addSuperbowlFAQ, updateIncentives, courseCx, updateAEMPartnerRegisterData, updateLangForPartnerSpanish, updateDateJson, updateInstructor, updateCourseCxJsonData, updateEventCxJsonData, updateResultsTopics, updateLearningPathFilters, updateInPersonEventCxJsonData, updateDisplayResolution } from './store/aem';
import { Helmet } from 'react-helmet';
import { updateIsMobile, updateIsIpad, updateIsLowResolutionDesktop } from './store/mediatype';
import store from './store/store';
import { retrieveAdobeData, retrieveJsonData, getGAPopularSearches, retrieveFileData, retrieveNotificationsData, getInfoHubHtml } from './utility/common';
import { quickTip_en, quickTip_es} from './mocks/quick_tip.js'
import { pageLoadStarted } from './common/Analytics/GAWrapper.jsx';
import { Loader } from '@vds/loaders';

export const storePartnerAndChannelFromPath = (pathname = window.location.pathname, search = window.location.search, storage = window.localStorage) => {
  if (!storage) return;

  const path = pathname || '';
  const rawSearch = search || '';

  const pathMatch = path.match(/(?:^|\/)(partner|channel)-([^/?#]+)/i);
  const queryMatch = rawSearch.match(/^\?(partner|channel)-([^?&#/]+)(?:\?goto=(.+))?$/i);

  const applyRouteIdentifiers = (type, id, gotoUrl) => {
    if (!type || !id) return;

    if (type === 'partner') {
      storage.setItem('partnerId', id);
    } else if (type === 'channel') {
      storage.setItem('channelId', id);
    }

    if (gotoUrl) {
      storage.setItem('prevUrl', gotoUrl);
    }
  };

  if (pathMatch && pathMatch[1] && pathMatch[2]) {
    applyRouteIdentifiers(pathMatch[1], pathMatch[2], rawSearch.startsWith('?goto=') ? decodeURIComponent(rawSearch.replace('?goto=', '')) : '');
    return;
  }

  if (path === '/onboarding' && queryMatch && queryMatch[1] && queryMatch[2]) {
    applyRouteIdentifiers(queryMatch[1], queryMatch[2], queryMatch[3] ? decodeURIComponent(queryMatch[3]) : '');
    return;
  }

  if (path === '/onboarding' || path === '/onboarding/partner' || path === '/onboarding/channel') {
    // Preserve any partner/channel context already captured from a partner URL while the
    // user enters the onboarding flow. We only clear these values after a successful
    // registration or when the source URL intentionally overrides them.
    return;
  }
};
const getPageTitle = (pathname = window.location.pathname) => {
  const entries = {
    '/': 'Landing',
    '/welcome': 'Landing',
    '/onboarding': 'Onboarding',
    '/account/settings': 'Account Settings',
    '/networking': 'Networking',
    '/grants': 'Grants',
    '/results/branding': 'Branding',
    '/results/funding': 'Funding',
    '/results/onlinemarketing': 'Online Marketing',
    '/results/winningcustomers': 'Winning Customers',
    '/results/websitedesign': 'Website Design',
    '/results/legalessentials': 'Legal Essentials',
    '/results/operations': 'Operations',
    '/results/socialmedia': 'Social Media',
    '/results/strategy': 'Strategy',
    '/results/cybersecurity': 'Cybersecurity',
    '/results/managingmoney': 'Managing Money',
    '/category/offers': 'Offers',
    '/category/courses': 'Courses',
    '/category/events': 'Events',
    '/category/quicktips': 'Quick Tips',
    '/super-bowl': 'Super Bowl - Grant',
  };

  const baseTitle = 'Verizon Small Business Digital Ready';
  const matchedTitle = entries[pathname] || entries[pathname.replace(/\/+$/, '')];
  return matchedTitle ? `${baseTitle} - ${matchedTitle}` : baseTitle;
};
const App = () => {
  const mediaQueryList = window.matchMedia('screen and (max-width:767px)');
  const tabletMediaQueryList = window.matchMedia('screen and (min-width:768px) and (max-width:1024px)');
  const lowResolutionDesktopMediaQueryList = window.matchMedia('screen and (min-width:1025px) and (max-width:1280px)');

  const aemData = useSelector((state) => state.Aem.data);
  const env = global.config.aemUrlEnv === "QA1" ? "QA2" : global.config.aemUrlEnv;

  const navigate = useNavigate();
  const [aemCSSFiles, setAemCSSFiles] = useState(null);
  const [minObject, setMinObject] =  useState(localStorage.getItem('aemConfigData') ? JSON.parse(localStorage.getItem('aemConfigData')) : null);
  // useMemo(() => {
  //   store.dispatch(updateCatalogData(minifiedCatalog));
  // }, []);

  //Load all the suggestion object

  useEffect(() => {
    document.title = getPageTitle(location.pathname);
  }, [location.pathname]);
  useEffect(() => {


    console.log("useeffect inside app.jsx")
    const location = window.location;
    const path = location.pathname;
    const rawSearch = location.search || '';
    const store = window.localStorage;
    let url = '';
    let prevUrl = '';
    console.log("Language",localStorage.getItem("lng"))
    url = store.getItem('url');
    // store.setItem('prevUrl', url);

    storePartnerAndChannelFromPath(path, rawSearch, store);

    if (path === '/onboarding' || path === '/onboarding/partner' || path === '/onboarding/channel') {
      // Keep the existing partner/channel values if the user enters onboarding via a
      // partner landing page or a standard register flow instead of forcing a localStorage reset.
      // The values are still cleared after successful registration on the submission path.
    }

    if (!path.startsWith('/onboarding') && !path.startsWith('/es/onboarding')) {
      store.setItem('url', path);
    }
    console.log("Url", store.getItem("prevUrl"))
    console.log("Url current", store.getItem("url"))
    const lang = localStorage.getItem("lng") ? localStorage.getItem("lng") : 'en';
    var variation = (lang === 'es') ? "prospect-es" : "prospect";
    console.log("**global.config",JSON.stringify(global.config));
    let appId = global.config.AEM_APP_ID ? global.config.AEM_APP_ID : "vsbdr";
    window.gnavdl = {
			"bu": "corporate",
			"appid": appId,
			"variation": variation
      // "options": { "hide-item": ["search"]}
		}
    console.log("**window.gnavdl",window.gnavdl);
   }, []);
  useMemo(() => {
    let payload= {allEvents:[], allCourses:[],learningPaths: [], allIPEvents: []};
    let suggestion = getSuggestionData();
    // let pastEvents = getWithExpiry('pastEvents');
    // if (pastEvents == null || pastEvents.length == 0) {
    //   retrievePastEvents().then((jsonPastEvents) => {
    //     if (jsonPastEvents) {
    //       setWithExpiry('pastEvents', jsonPastEvents.data, 3600000, jsonPastEvents.data.redisdate);
    //       payload.allPastEvents = Object.values(jsonPastEvents.data);
    //     }
    //   })
    // } else {
    //   payload.allPastEvents = Object.values(JSON.parse(localStorage.pastEvents).value);
    // }
    if(suggestion == null || suggestion.length == 0) {
      retrieveAdobeData()
      .then((jsonData) => {
        if (jsonData) {
          setWithExpiry('suggestion', LZString.compressToUTF16(JSON.stringify(jsonData.data)), 3600000, jsonData.data.redisdate);
          if(jsonData.data.courses || jsonData.data.events || jsonData?.data?.learningProgram || jsonData?.data?.inPersonEvents) {
            payload.allEvents = Object.values(jsonData.data.events);
            payload.allIPEvents = Object.values(jsonData.data.inPersonEvents);
            payload.allCourses = Object.values(jsonData.data.courses);
            payload.learningPaths = Object.values(jsonData.data.learningProgram);
            store.dispatch(updateCatalogData(payload));
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
    } else{
      if(suggestion.courses && suggestion.events && suggestion.inPersonEvents) {
        payload.allEvents = Object.values(suggestion.events);
        payload.allIPEvents = Object.values(suggestion.inPersonEvents);
        payload.allCourses = Object.values(suggestion.courses);
        payload.learningPaths = Object.values(suggestion.learningProgram);
        store.dispatch(updateCatalogData(payload));
      }
    }
  }, []);

  useEffect(() => {
      let env = 'qa1';
      switch(global.config.aemUrlEnv){
        case 'QA1' : env = 'qa2'; break;
        case 'QA2' : env = 'qa1'; break;
        case 'Pilot': env = 'pilot'; break;
        case 'PROD' : env = 'prod'; break;
      }
      let aemJSONURL = `${global.config.AEM_API_BASE_PATH}/content/dam/vsbdr/config-vsbdr/config.${env}.json`;
      if(localStorage.getItem('aemConfigData')) { return }
      else {
        getInfoHubHtml(aemJSONURL).then((response) => {
          if (response?.data?.isMinify) {
            const configData = {
              isMinified: response?.data?.isMinify,
              minifiedExt: response?.data?.clientlibExt,
              minifiedPath: response?.data?.minclientlibPath
          };
          setMinObject(configData);
          localStorage.setItem("aemConfigData", JSON.stringify(configData));
          } else {
            setMinObject(null);
          }
        });
      }
  }, [])

    useEffect(() => {
      const env = global.config.aemUrlEnv === 'QA1' ? '/QA1' : global.config.aemUrlEnv === 'QA2' ? '/QA2'  : '';
      setAemCSSFiles([
        `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${env}${minObject?.minifiedPath || ''}/css/common/fonts${minObject?.minifiedExt || ''}.css`,
        `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${env}${minObject?.minifiedPath || ''}/css/common/common${minObject?.minifiedExt || ''}.css`,
        `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${env}${minObject?.minifiedPath || ''}/css/common/icons${minObject?.minifiedExt || ''}.css`,
        `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${env}${minObject?.minifiedPath || ''}/css/common/theme${minObject?.minifiedExt || ''}.css`,
        `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${env}${minObject?.minifiedPath || ''}/css/common/typography${minObject?.minifiedExt || ''}.css`,
        `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${env}${minObject?.minifiedPath || ''}/css/offerCategory${minObject?.minifiedExt || ''}.css`,
        `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${env}${minObject?.minifiedPath || ''}/css/categoryOffers${minObject?.minifiedExt || ''}.css`,
        `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${env}/css/swiper-bundle.min.css`,
        `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${env}${minObject?.minifiedPath || ''}/css/swiper${minObject?.minifiedExt || ''}.css`,
        `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${env}${minObject?.minifiedPath || ''}/css/common/vds-icons${minObject?.minifiedExt || ''}.css`
      ]);
    }, [minObject] );

  useEffect(() => {
    retrieveJsonData('/content/vsbdr/' + global.config.aemUrlEnv + '/en/landingPage.quicktip.json')
      .then((jsonData) => {
        retrieveJsonData('/content/vsbdr/' + global.config.aemUrlEnv + '/es/landingPage.quicktip.json')
          .then((jsonDataES) =>{
          let englishQuickTips = jsonData?.quicktips?.quicktips || [];
          let spanishQuickTips = jsonDataES?.quicktips?.quicktips || [];
          let combinedQuickTips = [];

          const lng = localStorage.getItem('lng') || 'en';
          const quickTipData = lng === 'es' ? jsonDataES :jsonData;
            localStorage.setItem('allQuicktipsData', JSON.stringify(quickTipData?.quicktips?.quicktips || [] ));

          const additionalData = {
            quicktiptitle: quickTipData?.quicktiptitle,
            registertxt: quickTipData?.registertxt,
            registernwtxt: quickTipData?.registernwtxt,
            signinlabel: quickTipData?.signinlabel,
            alreadyMemberLabel: quickTipData?.alreadyMemberLabel,
            filterOptions: quickTipData?.filterOptions,
            qtcardtxt:quickTipData?.qtcardtxt,
            rssubtxt: quickTipData?.rssubtxt,
            viewall: quickTipData?.viewall,
            reglink: quickTipData?.reglink,
            signinlink: quickTipData?.signinlink,
            format: "Quick Tip"
          };

          const topicCardData = (jsonData?.topicSubText || []).filter(
            ([key, value]) => typeof key === 'string' && typeof value === 'string' && !key.includes(',') && !value.includes(',')
          );

          const recommended = Object.entries(quickTipData?.recommendedNew || {}).reduce((formattedRecommendations, [key, value]) => {
            const formattedKey = key.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
            formattedRecommendations[formattedKey === "Im Not Sure" ? "I'm not sure" : formattedKey] = value;
            return formattedRecommendations;
          }, {});
          const newTips = quickTipData?.new || [];

          const forceRankingData = {
            recommended,
            new: newTips,
          };

          localStorage.setItem("quickTipsForceRankingData", JSON.stringify(forceRankingData));

           const filtersData = {
            quickTipFilters: quickTipData?.quickTipFilters,
            topics: quickTipData?.topics,
            quicktiplabels: quickTipData?.quicktiplabels
          };

          englishQuickTips.forEach((e) => {
            let currentSpanishQuickTip = spanishQuickTips.filter(qt => qt.qtid === e.qtid);
              // e.locale.push('es-ES');
              currentSpanishQuickTip?.length > 0 ? e.locale.push('es-ES') : '';
              e.labelSpanish = currentSpanishQuickTip.length > 0 ? currentSpanishQuickTip[0].qtcardtitle : '';
              e.resourceTypeSpanish = currentSpanishQuickTip.length > 0 ? currentSpanishQuickTip[0].qttype : '';
              e.dateAndTimeValueSpanish = currentSpanishQuickTip.length > 0 ? currentSpanishQuickTip[0].qtdt : '';
              e.courseId = e.qtid;
              delete e.qtid;
              e.label = e.qtcardtitle;
              delete e.qtcardtitle;
              e.desktopImage = e.qtimage;
              delete e.qtimage;
              e.resourceType = e.qttype;
              delete e.qttype;
              e.dateAndTimeValue = e.qtdt;
              delete e.qtdt;
              if (e.publishedOnDate && typeof e.publishedOnDate === 'number') {
                const date = new Date(e.publishedOnDate);
                const options = { day: '2-digit', month: 'short', year: 'numeric' };
                e.publishedOnDate = date.toLocaleDateString('en-GB', options).replace(/, /g, ' ').replace(/ (\d{4})$/, ', $1');
              }
              e.expertsDetails = Array.isArray(e.expertsDetails) ? e.expertsDetails[0] : e.expertsDetails;
              e.deliveryMethod = Array.isArray(e.deliveryMethod) ? e.deliveryMethod[0] : e.deliveryMethod;
              e.desktopImage = e.desktopImage.includes('/content/dam/vsbdr') ? global.config.AEM_API_BASE_PATH + e.desktopImage : e.desktopImage;

              e.mobileImage =  global.config.AEM_API_BASE_PATH + e.mobileImage;
              e.deliveryMethod.closedCaptionFileURL =  global.config.AEM_API_BASE_PATH + e.deliveryMethod.closedCaptionFileURL;
              e.deliveryMethod.source =  global.config.AEM_API_BASE_PATH + e.deliveryMethod.source;
              e.deliveryMethod.thumbnailImage =  global.config.AEM_API_BASE_PATH + e.deliveryMethod.thumbnailImage;
              e.expertsDetails.profilePhoto =  global.config.AEM_API_BASE_PATH + e.expertsDetails.profilePhoto;
              if(e.format == "Quick Tip") {
                combinedQuickTips.push(e);
              }
          });
          const quickTipsData = {
            combinedQuickTips,
            additionalData,
            topicCardData,
            forceRankingData,
            filtersData
          };
          store.dispatch(updateAEMQuickTIpsData(quickTipsData));
        } )
        .catch((error) => {
          console.error(error,"error in spanish quicktips");
        });
      })
      .catch((error) => {
        console.error(error,"error in english quicktips");
      });
  }, []);

  useEffect(()=>{
    if(localStorage.combinedNotifications) {
      store.dispatch(updateNotifications(JSON.parse(localStorage.combinedNotifications)));
    } else {
        retrieveNotificationsData(`/content/vsbdr/${env}/en/landingPage.notification.json`,global.config.AEM_API_BASE_PATH).then((notifications_en)=>{
        retrieveNotificationsData(`/content/vsbdr/${env}/es/landingPage.notification.json`,global.config.AEM_API_BASE_PATH).then((notifications_es)=>{
          let combinedNotifications = {
            "en" : notifications_en,
            "es" : notifications_es
        }
        setWithExpiry("combinedNotifications", combinedNotifications, 10800000, new Date().getTime() + 10800000);
        store.dispatch(updateNotifications(combinedNotifications));
        }).catch((error) => {
          console.error(error,"error in spanish notifications");
        });
      }).catch((error) => {
        console.error(error,"error in english notifications");
      });
    }
}, []);

//Load All tips
//  useMemo(() => {
//     let englishQuickTips = Object.values(quickTip_en);
//     let spanishQuickTips = Object.values(quickTip_es);
//     store.dispatch(updateQuickTips(englishQuickTips.concat(spanishQuickTips)));
//   }, []);

  useEffect(() => {
    store.dispatch(updateIsMobile(mediaQueryList.matches));
    mediaQueryList.addEventListener('change', (e) =>
      store.dispatch(updateIsMobile(e.matches))
    );
  }, [mediaQueryList]);

  useEffect(() => {
    store.dispatch(updateIsIpad(tabletMediaQueryList.matches));
    tabletMediaQueryList.addEventListener('change', (e) =>
      store.dispatch(updateIsIpad(e.matches))
    );
  }, [tabletMediaQueryList]);

  useEffect(() => {
    store.dispatch(updateIsLowResolutionDesktop(lowResolutionDesktopMediaQueryList.matches));
    tabletMediaQueryList.addEventListener('change', (e) =>
      store.dispatch(updateIsLowResolutionDesktop(e.matches))
    );
  }, [lowResolutionDesktopMediaQueryList]);

  useEffect(() => {
    retrieveJsonData('static-contents/register/english/registerPage.json')
      .then((jsonData) => {
        store.dispatch(updateAEMRegisterData(jsonData));
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(()=>{
    const lng = location.href.indexOf('/es/') != -1 ? 'es' : 'en';
    retrieveJsonData(`/content/vsbdr/${env}/${lng}/category/instructors.instructor.json`, global.config.AEM_API_BASE_PATH).then((resp)=>{
      store.dispatch(updateInstructor(resp))
    })
  },[]);

  useEffect(()=>{
    const lng = location.href.indexOf('/es/') != -1 ? 'es' : 'en';
    retrieveJsonData(`/content/vsbdr/${env}/${lng}/course-details.courseCx.json`, global.config.AEM_API_BASE_PATH).then((resp)=>{
      store.dispatch(updateCourseCxJsonData(resp))
    })
  },[]);

  useEffect(()=>{
    const lng = location.href.indexOf('/es/') != -1 ? 'es' : 'en';
    retrieveJsonData(`/content/vsbdr/${env}/${lng}/course-details.eventCx.json`, global.config.AEM_API_BASE_PATH).then((resp)=>{
      store.dispatch(updateEventCxJsonData(resp))
    })
  },[]);

  useEffect(()=>{
    const lng = location.href.indexOf('/es/') != -1 ? 'es' : 'en';
    retrieveJsonData(`/content/vsbdr/${env}/${lng}/course-details.ipeventCx.json`, global.config.AEM_API_BASE_PATH).then((resp)=>{
      console.log("updateInPersonEventCxJsonData!!", resp)
      store.dispatch(updateInPersonEventCxJsonData(resp))
    })
  },[]);

  useEffect(() => {
    retrieveJsonData('static-contents/register/english/registerPage_partner.json')
      .then((jsonData) => {
        store.dispatch(updateAEMPartnerRegisterData(jsonData));
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(()=>{
    const lng = location.href.indexOf('/es/') != -1 ? 'es' : 'en';
    retrieveJsonData(`/content/vsbdr/${env}/${lng}/landingPage.common.json`, global.config.AEM_API_BASE_PATH).then((resp)=>{
      store.dispatch(updateLearningPathFilters(resp));

    if (resp?.imgData) localStorage.setItem('imgData', JSON.stringify(resp.imgData));
    if (resp?.cDamDomainPath) localStorage.setItem('cDamDomainPath', resp.cDamDomainPath);
    if (resp?.cDamVidDomainPath) localStorage.setItem('cDamVidDomainPath', resp.cDamVidDomainPath);

    })
  },[]);

  useEffect(() => {
    const lng = location.href.indexOf('/es/') != -1 ? 'es' : 'en';
    retrieveJsonData(`/content/vsbdr/${env}/en/landingPage.aisearch.json`, global.config.AEM_API_BASE_PATH).then((aemAiSearchData) => {
      store.dispatch(updateAICommonData(aemAiSearchData))

      const gaToggle = aemAiSearchData?.enableGAPopSch;
      if (gaToggle == "true") {
        getGAPopularSearches().then((resp) => {
          const gaPopularPillsData = resp?.map((item) => { return item?.searchQuery })
          localStorage.setItem('popSearch', JSON.stringify(gaPopularPillsData || []));
        }).catch((error) => {
          localStorage.setItem('popSearch', JSON.stringify(aemAiSearchData?.popularSearch) || []);
          console.log("Error fetching GA popular search data, falling back to AEM data", error);
        });
      } else {
        localStorage.setItem('popSearch', JSON.stringify(aemAiSearchData?.popularSearch) || []);
      }
    })
  }, []);

  useEffect(() =>{
  let isMobile = window.matchMedia('screen and (max-width:767px)').matches;
  let isTablet = window.matchMedia('screen and (min-width:768px) and (max-width:1023px)').matches;
  let isSmallDesktop = window.matchMedia('screen and (min-width:1024px) and (max-width:1232px)').matches;
  let isLargeDesktop = window.matchMedia('screen and (min-width:1233px)').matches;
    store.dispatch(updateDisplayResolution({isMobile, isTablet, isSmallDesktop, isLargeDesktop}))
  }, [])

  useEffect(() => {
    const lng = location.href.indexOf('/es/') != -1 ? 'es' : 'en';
    retrieveJsonData('static-contents/offersDetail.json')
      .then((jsonData) => {
        retrieveJsonData(`/content/vsbdr/${env}/${lng}/category/offers.offer.json`, global.config.AEM_API_BASE_PATH).then((offerList) => {

          const prepareForcedRanking = () => {
            const validOfferIds = new Set(offerList?.Offers?.Offers?.map((offer) => offer.id));
            localStorage.setItem('promotions', JSON.stringify(offerList?.Offers?.Offers));

            return Object.entries(offerList?.recommended || {})
                .filter(([key, ids]) => ids.length > 0)
                .reduce((acc, [key, ids]) => {
                let sanitizedKey = key.replace(/-/g, ' ');
                if (sanitizedKey === 'Im not sure') {
                  sanitizedKey = "I'm not sure";
                }
                const filteredIds = ids.filter((id) => validOfferIds.has(id));
                if (filteredIds.length > 0) {
                    acc[sanitizedKey] = filteredIds;
                }
                return acc;
            }, {});
          };
          const updatedForcedRanking = prepareForcedRanking();

          let offerData = {
            forcedRanking: updatedForcedRanking,
            offers: offerList?.Offers?.Offers?.map(e => addOfferStatus(e)),
            resourceDetailPageOfferCTATitle: offerList?.resourceDetailPageOfferCTATitle,
            resourceDetailPageOfferTitle: offerList.resourceDetailPageOfferTitle,
            topicPageOfferCTATitle: offerList.topicPageOfferCTATitle,
            topicPageOfferTitle: offerList.topicPageOfferTitle,
            infoHubOfferTitle: offerList.infoHubOfferTitle,
          }
          store.dispatch(updateAEMOffersJsonData(offerData));
        })
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    retrieveJsonData('static-contents/register/spanish/registerPage.json')
      .then((jsonData) => store.dispatch(updateLangSpanish(jsonData)))
      .catch((error) => {
        console.error(error);
      });
  }, []);
  useEffect(() => {
    retrieveJsonData('static-contents/register/spanish/registerPage_partner_es.json')
      .then((jsonData) => {
        store.dispatch(updateLangForPartnerSpanish(jsonData));
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  useEffect(() => {
    console.log("Language--",localStorage.getItem("lng"))
    let url=localStorage.getItem("lng")==='es'?'static-contents/coursecx/courseCx_es.json':'static-contents/coursecx/courseCx_en.json'
    retrieveJsonData(url)
      .then((jsonData) => store.dispatch(courseCx(jsonData)))
      .catch((error) => {
        console.error(error);
      });
  }, []);
  useEffect(() => {
    console.log("Language--",localStorage.getItem("lng"))
    let url=localStorage.getItem("lng")==='es'?'static-contents/FAQ_es.json':'static-contents/FAQ.json'
    retrieveJsonData(url)
      .then((jsonData) => store.dispatch(addFAQ(jsonData)))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    console.log("Language--",localStorage.getItem("lng"))
    let url=localStorage.getItem("lng")==='es'?'static-contents/SB_FAQ_es.json':'static-contents/SB_FAQ.json'
    retrieveJsonData(url)
      .then((jsonData) => store.dispatch(addSuperbowlFAQ(jsonData)))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    retrieveJsonData('static-contents/incentives/incentives_en.json')
      .then((jsonData) => store.dispatch(updateIncentives(jsonData)))
      .catch((error) => {
        console.error(error);
      });
  }, []);
  useEffect(() => {
    retrieveJsonData('static-contents/dashboardjson/recommendedCourses.json')
      .then((jsonData) => store.dispatch(updateRecommendedCourses(jsonData)))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    const lang = localStorage.getItem("lng") ? localStorage.getItem("lng") : 'en';
    retrieveJsonData('/content/vsbdr/' + global.config.aemUrlEnv + '/' + lang + '/landingPage.common.json')
      .then((jsonData) => store.dispatch(updateResultsTopics(jsonData)))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  // useEffect(() => {
  //   retrieveFileData('Article_content.html')
  //     .then((jsonData) => store.dispatch(updateArticleContent(jsonData)))
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // }, []);
  // useEffect(() => {
  //   retrieveFileData('Article_content.html')
  //     .then((jsonData) => store.dispatch(updateArticleContent(jsonData)))
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // }, []);

  // useEffect(() => {
  //   retrieveFileData('Howtoreclaimyourworkschedule.html')
  //     .then((jsonData) => store.dispatch(updateArticleContent(jsonData)))
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // }, []);

  useEffect(() => {
    // const lang = localStorage.getItem("lng") ? localStorage.getItem("lng") : 'en';
    // let languageBasedHref = getLanguageBasedHref();
    // if(!sessionStorage.isSwitchedLanguage && location.pathname.indexOf("/es") != -1 && lang != "es") {
    //   localStorage.setItem("lng","es");
    //   navigate(location.pathname);
    // }

    // if(languageBasedHref != null && languageBasedHref != location.pathname) {
    //   location.pathname =  languageBasedHref;
    // }

    //Redirect for the language changed
    if(localStorage.getItem('changedLanguage')) {
      localStorage.removeItem('changedLanguage');
      if(localStorage.getItem("lng") == "es" && location.pathname.indexOf("/es") == -1) {
        //location.pathname = '/es' + location.pathname;
        navigate('/es' + location.pathname);
        window.location.reload();
      }
      if(localStorage.getItem("lng") == "en" && location.pathname.indexOf("/es") != -1) {
        //location.pathname = location.pathname.replace('/es','');
        navigate(location.pathname.replace('/es',''));
        window.location.reload();
      }
    }

    //Added logic to change the language based on the URL
    if(localStorage.getItem("lng") != "es" && location.pathname.indexOf("/es") != -1) {
      localStorage.setItem("lng","es");
      window.location.reload();
    } else if(localStorage.getItem("lng") != "en" && location.pathname.indexOf("/es") == -1) {
      localStorage.setItem("lng","en");
      window.location.reload();
    }

    const handleLangSwitchClick = (event) => {
      if (event.target && event.target.className && event.target.className === 'gnav20-lang-link') {
        event.preventDefault();
        const langValue = event.target.getAttribute('data-lang');
        const userLang = (event && event.target && event.target.getAttribute('data-lang') && (event.target.getAttribute('data-lang') === 'English' || event.target.getAttribute('data-lang') === 'Inglés')) ? 'en' : 'es';
          const executeLanguageSwitch = () => {
            localStorage.setItem('lng', userLang);
            localStorage.setItem('changedLanguage', userLang);
            sessionStorage.setItem('isSwitchedLanguage', true);
            window.gnavdl.variation = (userLang && userLang === 'en') ? 'prospect' : 'prospect-es';
            const isSpanish = (userLang && userLang === 'en') ? false : true;
            store.dispatch(updateSpanish(isSpanish));
            let languageBasedHref = getLanguageBasedHref();
            if(languageBasedHref != null) {
              location.pathname =  languageBasedHref;
            } else {
              window.location.reload();
            }
          };
          if (window.isAskAIActive && (langValue === 'Spanish' || langValue === 'Español' || userLang === 'es')) {
            const interceptEvent = new CustomEvent('gnav-intercept-lang', {
              detail: { proceedWithSwitch: executeLanguageSwitch }
            });
            window.dispatchEvent(interceptEvent);

          } else {
            executeLanguageSwitch();
          }
      }
    };

    document.addEventListener('click', handleLangSwitchClick);
    document.addEventListener('touchstart', handleLangSwitchClick);
  }, []);

  useEffect(() => {
    // if (!aemData) {
      let langUI = localStorage.getItem("lng");
      if (langUI === 'es') {
          retrieveJsonData('static-contents/landing/landingPage_es.json')
          .then((jsonData) => {
          const courseDetails =
              jsonData?.TipsAndResourcesSectionData?.courseDetails?.map(
                (course, i) => {
                  return {
                    ...course,
                    courseId: i + 1,
                    courseType: course.courseType,
                  };
                }
              );
            jsonData.TipsAndResourcesSectionData.courseDetails = courseDetails;
            store.dispatch(updateAEMJsonData(jsonData));
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        retrieveJsonData('static-contents/landing/landingPage.json')
        .then((jsonData) => {

        const courseDetails =
            jsonData?.TipsAndResourcesSectionData?.courseDetails.map(
              (course, i) => {
                return {
                  ...course,
                  courseId: i + 1,
                  courseType: course.courseType,
                };
              }
            );
          jsonData.TipsAndResourcesSectionData.courseDetails = courseDetails;
          store.dispatch(updateAEMJsonData(jsonData));
         })
        .catch((error) => {
          console.error(error);
        });

      }
    // }
  }, []);

  useEffect(() => {
    let url=localStorage.getItem("lng")==='es'?'static-contents/dataanddates/dataanddates_es.json':'static-contents/dataanddates/dataanddates.json'
    retrieveJsonData(url)
      .then((jsonData) => {
        store.dispatch(updateDateJson(jsonData));
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);



  // return aemData ? (
  //   <>
  //     <Outlet />
  //   </>

  // ) : (
  //   <></>
  // );
   
  return (
      <>
      <Helmet>
          <title>{getPageTitle(location.pathname)}</title>
        {/* https://mbqa1.sdc.vzwcorp.com/content/dam/vsbdr/clientlibs/QA2/js/common.js */}
        <script  src={ `${config.AEM_API_BASE_PATH}${config.aemUrlPath}${config.aemUrlEnv === 'QA1' ? '/QA1' : config.aemUrlEnv === 'QA2' ? '/QA2' : ''}/js/jquery.js` } async></script>
        <script  src={ `${config.AEM_API_BASE_PATH}${config.aemUrlPath}${config.aemUrlEnv === 'QA1' ? '/QA1' : config.aemUrlEnv === 'QA2' ? '/QA2' : ''}/js/common.js` } async></script>
         <script  src={ `${config.AEM_API_BASE_PATH}${config.aemUrlPath}${config.aemUrlEnv === 'QA1' ? '/QA1' : config.aemUrlEnv === 'QA2' ? '/QA2' : ''}/js/aisearchcommon.js`}></script>

        {aemCSSFiles?.map((file, _) => (<link key={file} href={file} rel="stylesheet" type="text/css"></link>))}
      </Helmet>
        <Suspense fallback={<Loader fullscreen={true} active={true} surface="light"/>}>
          <Outlet />
        </Suspense>
      </>
  )
};

export default App;
